<template>
  <div class="train">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'Train'
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/academicActivities/index.vue